'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var style = {
  fontSize: '11px',
  display: 'block',
  padding: '4px'
};
var styleLabel = {
  display: 'block',
  color: '#666'
};

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.Group',

  propTypes: {
    name: _react.PropTypes.string.isRequired,
    children: _react.PropTypes.node.isRequired
  },

  render: function render() {
    var _props = this.props;
    var name = _props.name;
    var children = _props.children;

    return _react2['default'].createElement(
      'label',
      { style: style, className: 'react-demo__control-group' },
      _react2['default'].createElement(
        'span',
        { style: styleLabel, className: 'react-demo__control-group-label' },
        name
      ),
      children
    );
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/Group.js
// module id = 92
// module chunks = 0